module.exports = __webpack_public_path__ + "static/media/1006013.b528e6c0.png";